

































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {perRoadStore} from "@/store/store";
import {UnitSystem} from "@/interfaces/units";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import {
  ILayerPerformanceCriteriaImperial,
  ILayerPerformanceCriteriaMetric,
  IPerRoadLayerImperial,
  LayerPerformanceCriteriaLocation,
} from "@/modules/perRoad/interfaces/perRoad";
import PrHorizontalStrainDistributionPlot
  from "@/modules/perRoad/views/components/criteria/plots/PrHorizontalStrainDistributionPlot.vue";
import {IPrMonteCarloDrawImperial,} from "@/modules/perRoad/interfaces/monteCarlo";
import {
  getHorizontalStrainValuesFromWesleaResults,
  getPercentileAtValue,
} from "@/modules/perRoad/lib/calculations/horizontalStrainDistribution";
import {getCurrentError} from "@/modules/perRoad/lib/simulation/optimization";
import Optimization from "@/modules/perRoad/views/components/Optimization.vue";

const echarts = require("echarts");

@Component({
  components: {
    Optimization,
    PrHorizontalStrainDistributionPlot,
    PxNumberInput,
  },
})
export default class HorizontalStrainDistributionResults extends Vue {
  @Prop() performanceCriteria!: ILayerPerformanceCriteriaImperial | ILayerPerformanceCriteriaMetric;

  @Prop({default: 0}) externalKey!: number;


  @Prop() layerImperial!: IPerRoadLayerImperial;

  @Prop() layerNumber!: number;

  @Prop() draws!: IPrMonteCarloDrawImperial[];

  @Prop() id!: string;

  @Prop({default: false}) showResults!: boolean;

  internalKey = 0;

  get plotKey() {
    return this.internalKey + this.externalKey;
  }

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  get strainUnits() {
    return this.unitSystemIsImperial ? "x 10<sup>-6</sup>&nbsp&nbspin/in" : "x 10<sup>-6</sup>&nbsp&nbspcm/cm";
  }

  resetDistribution() {
    this.performanceCriteria.distributionPercentiles = [95, 85, 75, 65, 55];
    this.performanceCriteria.distribution_ustrain = [-257, -194, -158, -131, -110];
    this.sync();
  }

  calculateDistribution() {
    this.internalKey += 1;
  }

  /**
   * Watcher implemented because the usual reactive systems weren't picking up changes and updating the plot when
   * the simulation was switched from batch to individual processing.
   */

  horizontalStrainValues: number[] = [];

  @Watch("externalKey", {immediate: true})
  onKeyChanged(val: number, oldVal: number) {
    this.horizontalStrainValues = getHorizontalStrainValuesFromWesleaResults(this.draws, this.layerNumber, LayerPerformanceCriteriaLocation.BOTTOM);
    this.internalKey += 1;
  }

  get percentileAtTargetStrain(): number[] {
    let actualPercentiles: number[] = [];

    if (this.performanceCriteria.distribution_ustrain && this.performanceCriteria.distributionPercentiles) {
      actualPercentiles = getPercentileAtValue(
          this.horizontalStrainValues,
          this.performanceCriteria.distribution_ustrain,
          this.performanceCriteria.distributionPercentiles,
      );
    }

    return actualPercentiles;
  }

  get resultTable() {
    if (this.performanceCriteria.distributionPercentiles && this.performanceCriteria.distribution_ustrain) {
      return this.performanceCriteria.distributionPercentiles.map((pct, i) => ({
        // @ts-ignore
        uStrain: this.performanceCriteria.distribution_ustrain[i],
        targetPct: pct,
        actualPct: this.percentileAtTargetStrain[i] * 100,
        isSuccess: pct < this.percentileAtTargetStrain[i] * 100,
      }));
    }

    return [];
  }

  get resultError() {
    if (this.resultTable.length > 0) {
      return getCurrentError(this.resultTable);
    }
    return 0;
  }

  get isResultGood(): boolean {
    return true;
  }

  sync() {
    this.$emit("sync");
    this.internalKey += 1;
  }

  mounted() {
  }

  updated() {
  }
}
